module.exports = __webpack_public_path__ + "img/chp-coloured.070e5be7.svg";